module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bzkxj"))).then(() => parcelRequire('1iHdE'));